import {appFactory} from '@modifi/app'
import {compose} from 'ramda'
import {clientConfig} from '@modifi/client-config'
import {
  AUTH_TYPE_USER,
  CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL,
} from '@modifi/plugin-authentication/register'
import {withSuspense} from '@modifi/plugin-onboarding'
import ms from 'ms'

import routes from './routes'
import reducers from './reducers'
import {initPlugins} from './plugins'
import {withAbilityProvider} from './hoc'
import './dialogs/setup'

import dataMiddlewares from './data/redux-middleware'

const getApp = async (options = {}) => {
  await initPlugins(options?.plugins)
  /* Layout must be imported only after plugin-i18n(moment.js) initialization 
  because Layout imports FormInputContextProvider which uses moment.js  */
  const {Layout} = await import('./layouts')
  const hocFunc = options.useSuspense
    ? compose(withSuspense(true), withAbilityProvider)
    : withAbilityProvider

  clientConfig.set(CONFIG_KEY_AUTH_TOKEN_REFRESH_INTERVAL, ms('4m'))

  return appFactory({
    client: 'charon',
    appType: AUTH_TYPE_USER,
    routes,
    reducers,
    layout: Layout,
    storeMiddlewares: [...dataMiddlewares],
    hoc: hocFunc,
  })
}

export default getApp
